import { observer } from "mobx-react-lite";
import { useIntl } from "react-intl";

import { OpenNewWebsiteTemplateModal, WebsiteTemplateCreated } from "@/events";
import { EventBasedModal } from "@/ui/_common_/event-based-modal";

import { NewWebsiteTemplateForm } from "./form";

export const NewWebsiteTemplateModal = observer(() => {
  const intl = useIntl();
  return (
    <EventBasedModal
      title={intl.formatMessage({ defaultMessage: "Add template" })}
      openEvent={OpenNewWebsiteTemplateModal}
      closeEvent={WebsiteTemplateCreated}
    >
      {() => <NewWebsiteTemplateForm />}
    </EventBasedModal>
  );
});
